export default __webpack_public_path__ + "static/media/bg-sign-in-cover.e5dabb48.jpeg";